module.exports = __webpack_public_path__ + "assets/img/i10.6f8b564a.png";